<template>
    <div class="dataAnalysis">
        <div class="classes blod">直播概况</div>
        <div class="data_survey">
            <div class="data_item flex_wrap">
                <div class="data_item_flex">
                    <p class="title">
                        <span>在线人数（UV）</span>
                        <el-popover placement="top" trigger="hover" content="直播创建开始至今，进入直播间的用户总数（更新频率为2分钟）"  popper-class="topPopo">
                            <i slot="reference" class="el-icon-info"></i>
                        </el-popover>
                    </p>
                    <p class="dataNum">{{liveuviewcount}}</p>
                </div>
                <div class="data_item_flex line"></div>
                <div class="data_item_flex">
                    <p class="title">
                        <span>在线人次（PV）</span>
                        <el-popover placement="top-end" trigger="hover" content="直播创建开始至今，用户进入直播间的总次数（更新频率为2分钟）"  popper-class="topPopo">
                        <i slot="reference" class="el-icon-info"></i>
                        </el-popover>
                    </p>
                    <p class="dataNum">{{livepviewcount}}</p>
                </div>
            </div>
            <div class="data_item flex_wrap">
                <div class="data_item_flex">
                    <p class="title">
                        <span>分享次数 </span>
                        <el-popover placement="top" trigger="hover" content="通过邀请首次进入直播次数"  popper-class="topPopo">
                            <i slot="reference" class="el-icon-info"></i>
                        </el-popover>
                    </p>
                    <p class="dataNum">{{sharecount}}</p>
                </div>
                <div class="data_item_flex line"></div>
                <div class="data_item_flex">
                    <p class="title">
                        <span>评论次数 </span>
                        <el-popover placement="top-end" trigger="hover" content="用户发起评论总次数"  popper-class="topPopo">
                            <i slot="reference" class="el-icon-info"></i>
                        </el-popover>
                    </p>
                    <p class="dataNum">{{commentcount}}</p>
                </div>
            </div>
            <div class="data_item">
                <p class="title">
                    <span>人均在线时长</span>
                    <el-popover placement="top" trigger="hover" content="所有用户在线总时长/累计在线人数（更新频率为2分钟）。在线时长：直播创建开始至今用户进入直播间停留时长"  popper-class="topPopo">
                        <i slot="reference" class="el-icon-info"></i>
                    </el-popover>
                </p>
                <p class="dataNum">{{liveviewlength}}</p>
            </div>
            <div class="data_item">
                <p class="title">
                    <span>新增粉丝</span>
                    <el-popover placement="top-end" trigger="hover" content="通过本直播关注公众号总数"  popper-class="topPopo">
                        <i slot="reference" class="el-icon-info"></i>
                    </el-popover>
                </p>
                <p class="dataNum">{{newfanscount}}</p>
            </div>
        </div>
        <!--echarts图-->
        <div class="echartsBox">
            <div class="echartsTitle">
                <div class="classes blod">直播在线人数
                    <el-popover placement="bottom" trigger="hover" content="仅展示直播开始前后7天的数据"  popper-class="topPopo">
                        <i slot="reference" class="el-icon-info"></i>
                    </el-popover>
                </div>
                <div class="right_select">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="sureSelect">确认筛选</el-button>
                </div>
            </div>
            <div class="echert" v-if="showEchart">
                <lineReport :lineDatas="lineDatas" class="lineDatas" id="lineChart"></lineReport>
            </div>
        </div>
        <!--直播观看详情-->
        <div class="seeDet">
            <div class="seeTop filters">
                <div class="classes blod">直播观看详情</div>
                <div class="search">
                    <el-input v-model.trim="param.customername" placeholder="输入用户昵称" class="condition" clearable></el-input>
                    <el-button type="primary" plain @click="handleQuery">搜索</el-button>
                    <el-button type="primary" plain @click="_export">直播数据导出</el-button>
                </div>
            </div>
            <div class="result-list">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="customername" label="用户昵称"></el-table-column>
                    <el-table-column prop="viewlength" label="在线时长" class-name="center"></el-table-column>
                    <el-table-column prop="datetime" label="首次进入时间" class-name="center"></el-table-column>
                    <el-table-column property="address" label="操作" class-name="delText" label-class-name="tr">
                        <template slot-scope="scope">
                            <span  @click="handleSee(scope.row)">查看用户</span>
                        </template>
                    </el-table-column>
                </el-table>
                <page :total="total" @getList="_getList" ref="page"></page>
            </div>
        </div>
        <UserInfo ref="userInfo"></UserInfo>
    </div>
</template>

<script>
    import {getLiveEventLineChartByDay,getLiveEventViewInfoByUser,getLiveEventViewInfoByExport} from 'api/vliveV2Api'
    import {mapGetters, mapActions} from 'vuex'
    import UserInfo from '@/views/vliveV2/components/userInfo'
    import Page from 'base/page/page'
    import LineReport from 'base/echarts/lineReport'
    import {dateFormat} from 'common/js/tools'
    export default {
        name: "dataAnalysis",
        data(){
            return{
                lineDatas: {id: 'saleData', subText: '', xdata: [], data: [], legendAddr: 'left'},
                param:{
                    liveid:'',
                    customername:'' //姓名
                },
                postData:{
                    liveid:'',
                    begintime:'', //开始时间
                    endtime:'', //结束时间
                },
                date:[],
                livepviewcount:'', //累计在线人次
                liveuviewcount:'', //累计在线人数
                liveviewlength:'', //人均在线时长
                sharecount:'', //分享次数
                commentcount:'', //评论次数
                newfanscount:'', //新增粉丝
                tableData:[],
                total:0,
                liveData:{}, //直播观看echarts
                showEchart:null
            }
        },
        mounted(){
          this.param.liveid=this.liveInfo.liveid
          this.postData.liveid=this.liveInfo.liveid
          this.getPerson();
          this._getList();
        },
        methods:{
            sureSelect(){
                this.postData.begintime = this.date[0]
                this.postData.endtime = this.date[1]
                this.getPerson()
            },
            //获取直播在线人数
            getPerson() {
                this.setLoading(true);
                getLiveEventLineChartByDay({
                    data: Object.assign({}, this.postData),
                    success: data => {
                        this.setLoading(false)
                        this.livepviewcount=data.data.livepviewcount
                        this.liveuviewcount=data.data.liveuviewcount
                        this.liveviewlength=data.data.liveviewlength
                        this.sharecount=data.data.sharecount
                        this.commentcount=data.data.commentcount
                        this.newfanscount=data.data.newfanscount
                        this.showEchart=data.data
                        this.lineDatas.xdata = data.data.xdate
                        this.lineDatas.data=[]
                        this.lineDatas.data.push(
                            {
                                title: '',
                                color: '#409EFF',
                                smooth: true,
                                symbol: 'circle',
                                list: data.data.zhexianlist
                            }
                        )
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //搜索
            handleQuery(){
                this.$refs.page.handleSizeChange(1)
            },
            //获取观看详情
            _getList(){
                this.setLoading(true)
                getLiveEventViewInfoByUser({
                    data: Object.assign({}, this.param,this.page),
                    success: data => {
                        this.setLoading(false)
                        this.tableData = data.data.content
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //查看用户
            handleSee(row){
                this.$refs.userInfo.open(row.innerid);
            },
            //直播导出
            _export(){
                this.setLoading(true)
                getLiveEventViewInfoByExport({
                    data: Object.assign({}, this.param),
                    success: data => {
                        this.setLoading(false)
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '直播数据' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading','setLiveInfo','setPlayInfo'
            ])
        },
        computed: {
            ...mapGetters([
                'liveInfo','playInfo','page'
            ])
        },
        components: {
            UserInfo,Page,LineReport
        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    @import "~common/scss/base";
    @import "~common/scss/variable";
    .dataAnalysis{
        .classes{
            margin-bottom: 0;
        }
        .data_survey{
            display: flex;
            justify-content: space-between;
            padding-top: 20px;
            .flex_wrap{
                display: flex;
                justify-content: space-between;
                .line{
                    width: 1px;
                    height: 30px;
                    background: #E4E7ED;
                    display: flex;
                    align-self: center;
                }
            }
            .data_item{
                width: 100%;
                height: auto;
                padding: 20px;
                border:1px solid rgba(220,223,230,1);
                margin-right: 30px;
                .title{
                    display: flex;
                    justify-content: space-between;
                    .el-icon-info{
                        font-size: 14px;
                        color: #C0C4CC;
                        cursor: pointer;
                        margin-left: 8px;
                    }
                }
                .dataNum{
                    font-size: 24px;
                    color: #409EFF;
                    padding-top: 20px;
                    line-height: 28px;
                }
            }
            .data_item:last-child{
                margin-right: 0;
            }
        }
        .echartsBox{
            margin-top: 20px;
            .echert{
                width: 100%;
                height: 100%;
                canvas{
                    width: 100%!important;
                    height: 100%!important;
                }
            }
            .echartsTitle{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .right_select{
                    display: flex;
                    .el-range-editor.el-input__inner{
                        width: 250px;
                        padding: 0 0;
                    }
                    .el-date-editor .el-range__icon{
                        padding-left: 10px;
                    }
                    .el-button{
                        margin-left: 10px;
                    }
                }
            }
            .el-icon-info{
                font-size: 14px;
                color: #C0C4CC;
                cursor: pointer;
            }
        }
        .seeDet{
            margin-top: 10px;
            .filters input{
                height: 32px;
            }
            .seeTop{
                display: flex;
                justify-content: space-between;
            }
            .result-list{
                .delText{
                    .cell{
                        text-align: right;
                        span{
                            color: #409EFF;
                            cursor: pointer;
                        }
                    }
                }
                .center{
                    .cell{
                        text-align: center;
                    }
                }
            }
        }
    }
    .topPopo{
        padding: 10px;
    }
</style>
